<header>
  {{
    $safeNavigationMigration(entry()?.time) | date: 'yyyy-MM-dd hh:mm:ss aaa'
  }}
  {{ entry()?.user }}
  @if (entry()?.isResolution) {
    <span class="resolution-msg"
      >- {{ 'MONLOG.LABEL.RESOLUTION' | translate | uppercase }}</span
    >
  }
  @if (entry()?.controlRoomInvolved) {
    <span class="cr-involved"
      >- {{ 'MONLOG.LABEL.CR_INVOLVED' | translate | uppercase }}</span
    >
  }
  <span>
    @if (canEdit()) {
      <i
        class="fa fa-edit"
        (click)="this.editEvent.emit(entry())"
        title="Edit Entry"
      ></i>
    }
    @if (canDelete()) {
      <i
        class="fa fa-trash"
        (click)="this.deleteEvent.emit(entry())"
        title="Delete Entry"
      ></i>
    }
  </span>
</header>
@if (entry()?.Category) {
  <span class="category">{{ entry()?.Category?.name }}</span>
}
<main [innerHTML]="$safeNavigationMigration(entry()?.note)"></main>
